<app-country-dialog (select)='selectCountry($event)' [visibleCountry]="visibleCountry"></app-country-dialog>
<form [formGroup]="form">


  <div class="d-flex flex-row-reverse">
    <div *ngIf="showSave && false" (click)="save()" class="btn btn-danger">Sauvguarder P</div>
  </div>



  <div class="row" style="margin-bottom: 30px;">

    <div class="col-sm-6">
      <mat-card>

        <div class="row" style="margin-right:-10px!important;margin-left:-10px!important; ">


          <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
            <mat-form-field>
              <input matInput placeholder="Raison Social" formControlName="raisonSocial" required>

            </mat-form-field>
          </div>



          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-form-field>
              <input type="number" matInput placeholder="N° Ordre" formControlName="ordre" required>

            </mat-form-field>
          </div>





        </div>

        <div class="row" style="margin-right:-10px!important;margin-left:-10px!important; display: none;">
          <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">

            <mat-form-field *ngIf="typeClient!='P'">
              <input matInput placeholder="Signalétique" formControlName="signalitique">
            </mat-form-field>

          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">

            <mat-form-field style="width: 100% ;  ">
              <mat-select formControlName="pavillon" placeholder="Pavillon">
                <mat-option [value]="''">

                </mat-option>
                <mat-option [value]="'France'">
                  France
                </mat-option>
                <mat-option [value]="'Chine'">
                  Chine
                </mat-option>
                <mat-option [value]="'Russe'">
                  Russe
                </mat-option>
              </mat-select>

            </mat-form-field>
          </div>
        </div>






        <div class="row" style="margin-right:-10px!important;margin-left:-10px!important; ">

          <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" style="float: left;">
            <mat-form-field>
              <input matInput placeholder="Addresse" formControlName="adresse" required>
            </mat-form-field>
          </div>


          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" style="float: left;">

            <mat-form-field>
              <input matInput placeholder="Pays" (click)="visibleCountry=true" formControlName="pays" required>
            </mat-form-field>

          </div>

          <div *ngIf="false" class="col-xs-4 col-sm-4 col-md-4 col-lg-4" style="float: left;">
            <mat-form-field floatPlaceholder="Pays">
              <input matInput placeholder="Pays" [matAutocomplete]="autocompletePaysId" formControlName="paysActivite">
            </mat-form-field>

            <mat-autocomplete #autocompletePaysId="matAutocomplete" [displayWith]="displayPaysFn">
              <mat-option *ngFor="let pays of payss | async" [value]="pays">
                {{pays.designationFr}}
              </mat-option>
            </mat-autocomplete>
          </div>





        </div>


        <!--
     <mat-form-field *ngIf="false" floatPlaceholder="Secteur d'activité">
          <textarea  matInput placeholder="Secteur d'activité" [matAutocomplete]="autocompleteSecteurId"
            formControlName="secteurActivite"></textarea>
        </mat-form-field>

        <mat-autocomplete #autocompleteSecteurId="matAutocomplete">
          <mat-option *ngFor="let secteur of secteurs | async" [value]="secteur.designation">
            {{secteur.designation}}
          </mat-option>
        </mat-autocomplete>


-->


        <div class="row">





          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">




            <mat-form-field style="width: 100%">
              <mat-select placeholder="Langue" [(value)]="selectedLangue" formControlName="langue">
                <mat-select-trigger>

                  <div>
                    <div style="float: left;">
                      <img width="15" [src]="'assets/img/'+selectedLangue+'.png'" alt="">
                    </div>
                    <div style="float: left;">
                      <div> {{ selectedLangue | uppercase}} </div>
                    </div>
                  </div>

                </mat-select-trigger>
                <mat-option *ngFor="let item of languages" [value]="item.value">
                  <img width="20" [src]="'assets/img/'+item.value+'.png'" alt="">
                  {{ item.value | uppercase}} - {{ item.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">

            <mat-form-field style="width: 100%">
              <mat-select placeholder="Invoicing Company" formControlName="sociFact">
                <mat-option *ngFor="let item of socifacts | async" [value]="item.raisonSocial"
                  (onSelectionChange)='changeSociFact()'>
                  {{item.raisonSocial}}
                </mat-option>
              </mat-select>
              <mat-error>Company Name is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <mat-form-field style="width: 100%">
              <mat-select placeholder="Currency" [(value)]="selectedDevise" formControlName="devise"
                (selectionChange)='changeDevise()'>
                <mat-select-trigger>

                  <div>
                    <div style="float: left;">
                      <img width="15" [src]="'assets/img/'+selectedDevise+'.png'" alt="">
                    </div>
                    <div style="float: left;">
                      <div> {{ selectedDevise | uppercase}} </div>
                    </div>
                  </div>

                </mat-select-trigger>
                <mat-option *ngFor="let item of devises" [value]="item.value">
                  <img width="20" [src]="'assets/img/'+item.value+'.png'" alt="">
                  {{ item.value | uppercase}} - {{ item.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
        <div class="row">

          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <mat-form-field style="width: 100%">
              <mat-select placeholder="Status" formControlName="statusjudiciaire">
                <mat-option [value]="''"> </mat-option>
                <mat-option [value]="'Nationale  Étatique'">Nationale Étatique </mat-option>
                <mat-option [value]="'Multinationale étrangère'"> Nationale privé </mat-option>
                <mat-option [value]="'Multinationale Locale'">Multinationale Locale </mat-option>

                <mat-option [value]="'Étrangère'"> Étrangère </mat-option>
              </mat-select>





            </mat-form-field>
          </div>

          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <mat-form-field>


              <mat-select placeholder="Historique du participation" formControlName="historique">
                <mat-option *ngFor="let fidelite  of fideliteList" [value]="fidelite">{{fidelite}}</mat-option>
              </mat-select>

            </mat-form-field>



          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <mat-form-field>

              <mat-select placeholder="Origine du contact" formControlName="origineContact">
                <mat-option [value]="''"> </mat-option>
                <mat-option [value]="'Déjà client'"> Déjà client </mat-option>
                <mat-option [value]="'Inscription en ligne'"> Inscription en ligne </mat-option>
                <mat-option [value]="'Campagne emailing'"> Campagne emailing </mat-option>
                <mat-option [value]="'Prospection Nationale'"> Prospection Nationale </mat-option>
                <mat-option [value]="'Prospection Internationale'">Prospection Internationale </mat-option>
                <mat-option [value]="'Recommandation'"> Recommandation </mat-option>

              </mat-select>





            </mat-form-field>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="col-sm-6">

      <mat-card>

        <div class="row">

          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input matInput placeholder="NRC" formControlName="nrc" required>
            </mat-form-field>
          </div>

          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input matInput placeholder="NIF" type="text" formControlName="nif" required>
            </mat-form-field>
          </div>



        </div>

        <mat-form-field>
          <input matInput placeholder="NAI" type="text" formControlName="nai" required>
        </mat-form-field>
        <div class="row">

          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input matInput placeholder="VAT Number" type="text" formControlName="vatNumber">

            </mat-form-field>
          </div>

          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <mat-form-field>
              <input matInput placeholder="Registration Number" type="text" formControlName="rcNumber">

            </mat-form-field>
          </div>




        </div>











      </mat-card>
    </div>






    <div *ngIf="false" class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
      <mat-card style="background: #F2F2F2;">
        <mat-form-field>
          <input matInput placeholder="Secteur" formControlName="raisonSocial" required>
        </mat-form-field>







        <mat-form-field>



          <input type="text" placeholder="Assignee" aria-label="Assignee" matInput [formControl]="form.controls.pays"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>



        <mat-form-field>
          <input matInput placeholder="Wilaya" type="text" formControlName="nif" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Addresse" type="text" formControlName="nai" required>
        </mat-form-field>
      </mat-card>
    </div>


  </div>





</form>